function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconsubmitfeedback = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.924,
    height: 12.797,
    viewBox: "0 0 10.924 12.797",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.994 4a1.174 1.174 0 0 0-.956.595c-.009.012-.022.017-.029.029L8.527 9.4A2.816 2.816 0 0 0 8 11.052v2.936a2.819 2.819 0 0 0 2.809 2.812h5.93a1.621 1.621 0 0 0 1.131-.449 1.273 1.273 0 0 0 .429-.9 1.79 1.79 0 0 0-.127-.654 1.268 1.268 0 0 0 .751-1.18 1.2 1.2 0 0 0-.429-.927 1.333 1.333 0 0 0 .429-.985 1.188 1.188 0 0 0-.7-1.122A3.8 3.8 0 0 0 18.3 9.9a1.318 1.318 0 0 0-1.424-1.19h-.01c-.969-.028-3.31-.029-3.892-.029.1-.233.179-.4.371-.829.291-.661.6-1.353.693-1.619v-.01a1.982 1.982 0 0 0 .2-.79 1.474 1.474 0 0 0-.438-1.092A1.193 1.193 0 0 0 12.994 4zm0 .624a.655.655 0 0 1 .38.176.8.8 0 0 1 .244.634 1.47 1.47 0 0 1-.166.575v.01c-.062.174-.38.918-.673 1.58s-.566 1.268-.566 1.268a.312.312 0 0 0 .283.439s3.318 0 4.36.029h.01c.582 0 .81.368.81.566a7.22 7.22 0 0 1-.088.79.311.311 0 0 0 .2.341.744.744 0 0 1 .507.673.964.964 0 0 1-.458.732.312.312 0 0 0 .029.566.678.678 0 0 1 .429.614c0 .515-.644.761-.644.761a.312.312 0 0 0-.146.478 1.065 1.065 0 0 1 .166.595.766.766 0 0 1-.234.449.987.987 0 0 1-.7.273h-5.93a2.189 2.189 0 0 1-2.185-2.185v-2.936a2.165 2.165 0 0 1 .41-1.278v-.01l3.492-4.8.02-.029a.568.568 0 0 1 .45-.311z",
    transform: "translate(-8 -4)",
    style: {
      fill: "#5a5a5a"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconsubmitfeedback);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.submitfeedback.9fe1541a37c7871da9c6f5796c4d02b7.svg";